import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import { Button } from '../../../components';

export const ThreatsCountLabel = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontFamily: theme.typography.fontFamily,
  fontSize: '18px',
  fontWeight: 600,
  color: theme.palette.text.primary,
  paddingRight: '16px',
  marginRight: '16px',
  borderRight: `1px solid ${theme.palette.divider}`,
  whiteSpace: 'nowrap',
}));

export const InputContainer = {
  display: 'flex',
  justifyContent: 'flex-start',
  mt: 3,
};

export const ThreatCardContainer = styled(Box)({
  flexGrow: 1,
  marginTop: '16px',
});

export const LoaderThreatTable = styled(Box)({
  alignItems: 'center',
  height: '50vh',
  display: 'flex',
  justifyContent: 'center',
});

export const ThreatCardWrapper = styled(Box)({
  width: '100%',
  justifyContent: 'center',
  display: 'flex',
  marginTop: '12%',
});

export const ModalWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '600px',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[24],
  padding: theme.spacing(4),
}));

export const ButtonWrapper = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '24px',
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 8,
  right: 8,
  color: theme.palette.text.primary,
}));

export const SelectedButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent !important',
  fontFamily: theme.typography.fontFamily,
  fontSize: '14px',
  color: theme.palette.primary.dark,
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
  '&.MuiButton-root': {
    padding: 1,
  },
}));
